import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from "./slices/authSlice"
import appReducer from './slices/appSlice';
import filterReducer from "./slices/filter";
import apiRegistry from "utils/apiRegistry";

// Configure persist for auth reducer
const persistConfig = {
  key: 'auth',
  storage,
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const rootReducer = {
  auth: persistedAuthReducer,
  app: appReducer,
  filter: filterReducer,
}

const middlewares = [];

apiRegistry.forEach(api => {
  rootReducer[api.reducerPath] = api.reducer;
  middlewares.push(api.middleware);
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      ...middlewares
    ),
})

export const persistor = persistStore(store);

setupListeners(store.dispatch)